import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { syncSprintDialog } from './entrypoint';
import type { Props as SyncSprintProps } from './types';

const AsyncSprintAssociationDialog = (props: SyncSprintProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(syncSprintDialog, {});

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
		return () => {
			entryPointActions.unload();
		};
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="plan-increment-sprint-association-dialog"
			packageName="jiraPortfolio3PlanIncrementCommon"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={props}
		/>
	);
};

export default AsyncSprintAssociationDialog;
